import React, { useMemo } from 'react'
import { Link } from 'react-router';
import { HomeIcon, SettingsIcon } from '../../../../utils/icons';
import DoubleArrowTwoToneIcon from "@material-ui/icons/DoubleArrowTwoTone";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { connect } from 'react-redux';
import { game_logo_path_map, platform_logo_path_map } from '../../../../utils/constantInformation';
import { goHome, timeFrameDisplay } from '../utils';
import { goBackBoolean } from '../../../../redux/GameInformation/GameInformationAction';

const Navbar = React.memo((props) => {
    function changeView() {
        props.view_setter("default_page");
        console.log("-- GameInfoExp --> Change View called");
        props.go_back_boolean(true);
    }

    return (
        <nav className="navbar navbar-expand-md fixed-top-sm flex-nowrap justify-content-between bg-dark navbar-dark">
            <Link
                to="/"
                onClick={changeView}
                style={
                    props.game_information_info.gameInformationReducer.view_selected ==
                        "Players"
                        ? {}
                        : { display: "none" }
                }
                className="align-items-center align-self-center"
            >
                <ArrowBackIosIcon className="align-items-center align-self-center text-primary"></ArrowBackIosIcon>
            </Link>

            <Link
                className="d-flex"
                style={
                    props.game_information_info.gameInformationReducer.view_selected ==
                        "Players"
                        ? { display: "none" }
                        : {}
                }
            >
                <SettingsIcon
                    className="align-items-center align-self-center text-primary"
                    data-toggle="modal"
                    data-target="#staticBackdropUserProfile"
                    style={{ cursor: "pointer" }}
                    disabled={
                        props.game_information_info.gameInformationReducer
                            .view_selected == "Players"
                            ? true
                            : false
                    }
                ></SettingsIcon>
                <HomeIcon
                    className="ml-1 align-items-center align-self-center text-primary home-logo"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => goHome(e)}
                />
            </Link>
            <button
                className="btn px-2 nav-item active align-items-center align-self-center central-button"
                onClick={async () => {
                    await props.handleClickOpen();
                }}
                data-toggle="modal"
                data-target="#staticBackdrop"
                disabled={
                    props.game_information_info.gameInformationReducer.view_selected ==
                        "Players"
                        ? true
                        : false
                }
            >
                <span>
                    <img
                        src={`${platform_logo_path_map["dream11"]}`}
                        className="platform__logo"
                    />
                </span>
                <span className="text-white">{" | "}</span>{" "}
                <span>
                    <img
                        src={`${game_logo_path_map[props.game_information_info.gameInformationReducer.sports]}`}
                        className="platform__logo" // game__logo
                    />
                </span>
                {timeFrameDisplay(props.game_information_info.gameInformationReducer.selected_timeframe)}
                <p className="m-0 p-0 text-primary lead">
                    <b className="text-bold">DailyFantasy </b>
                    <span>
                        <DoubleArrowTwoToneIcon className="rotate-90-clock" />
                    </span>
                </p>
            </button>
            <div className="d-flex justify-content-center">
                <span
                    className="iconify align-items-center align-self-center text-primary ml-1 morevert_logo font-weight-bold"
                    data-toggle="modal"
                    data-target="#staticBackdropLineUp"
                    style={{ cursor: "pointer" }}
                    disabled={
                        props.game_information_info.gameInformationReducer
                            .view_selected == "Players"
                            ? true
                            : false
                    }
                    data-icon="fa-solid:crown"
                ></span>
            </div>

            <button
                className="navbar-toggler ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="#navbar2"
                id="hamburger_btn"
                style={
                    props.game_information_info.gameInformationReducer.view_selected ==
                        "Players"
                        ? { display: "none" }
                        : {}
                }
            >
                <span
                    className="navbar-toggler-icon"
                    style={
                        props.game_information_info.gameInformationReducer
                            .view_selected == "Players"
                            ? { display: "none" }
                            : {}
                    }
                ></span>
            </button>
        </nav>
    )
})
const mapStateToProps = (state) => ({
    game_information_info: state,
})

const mapDispatchToProps = (dispatch) => {
    return {
        go_back_boolean: (value) => dispatch(goBackBoolean(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)
